import { toast, Zoom } from "react-toastify";

export default function createSocketToToast(
  socket = null,
  eventName = null,
  reportName = null,
  setProgresso = () => null
) {
  const toastId = toast.loading("Preparing to generate report...");
  socket.off(eventName).on(eventName, (data) => {
    setProgresso(data.progress);
    if (data.progress === 100) {
      toast.update(toastId, {
        render: () => (
          <div className="flex flex-row items-center justify-between">
            <div className="flex flex-col items-start justify-center">
              <h3 className="text-sm">
                <strong>{reportName}</strong>
              </h3>
              <span className="text-xs">Report generated!</span>
            </div>
          </div>
        ),
        type: "success",
        autoClose: 3000,
        isLoading: false,
      });
    } else {
      toast.update(toastId, {
        render: () => (
          <div className="flex flex-row items-center justify-between">
            <div className="flex flex-col items-start justify-center">
              <h3 className="text-sm">
                <strong>{reportName}</strong>
              </h3>
              <span className="text-xs">Generating report, please wait...</span>
            </div>
            <span className="text-lg">{data.progress}%</span>
          </div>
        ),
        type: "info",
        autoClose: false,
        isLoading: true,
      });
    }
  });
}
